import { Injectable, Injector } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { BaseCrudService } from 'projects/ProjetoBaseAngular/domain/services/base-crud.service';
import { GrupoProcedimentoModel } from '../models';
import { SelectDto } from 'projects/ProjetoBaseAngular/domain/models/select-dto';

@Injectable({
  providedIn: 'root'
})
export class GrupoProcedimentoService extends BaseCrudService<GrupoProcedimentoModel> {

  constructor(injector: Injector) {
    super(injector);
  }

  public getController(): string {
    return 'GrupoProcedimento';
  }

  getSelectList(): Observable<SelectDto[]> {
    return this
      .httpClient
      .get<GrupoProcedimentoModel>(`${this.getApiUrl()}${this.getController()}/GetSelectList`, this.getAuthHeaderJson())
      .pipe(
        map(this.extractData),
        catchError(this.serviceError)
      );
  }
}
